import PageNotifications from './PageNotifications';

export default PageNotifications;
